import TableActions from '../components/TableActions';
import StatusInfoCell from '../components/StatusInfoCell';

export const DEFAULT_COLUMNS = [
  { field: 'id', maxWidth: 100 },
  { field: 'title' },
  { field: 'description' },
  { field: 'duration_seconds', headerName: 'Duration (s)' },
  {
    field: 'is_active',
    headerName: 'Status',
    cellRenderer: ({ value }) => <StatusInfoCell status={value} />
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellClass: 'no-border',
    cellRenderer: (params) => {
      return <TableActions {...params} />;
    },
    maxWidth: 88,
    minWidth: 36,
    resizable: false,
    sortable: false,
    pinned: 'right'
  }
];

export const DEFAULT_FILTERS = {
  search: {
    type: 'search',
    fields: [
      { field: 'id', label: 'ID' },
      { field: 'title', label: 'Title' },
      { field: 'description', label: 'Description' }
    ]
  },
  id: {
    title: 'ID',
    values: null,
    allowed_operators: ['contains', 'does not contain'],
    icon: 'text-num-mono'
  },
  title: {
    title: 'Title',
    values: null,
    allowed_operators: ['contains', 'does not contain'],
    icon: 'first-line-mono'
  },
  description: {
    title: 'Description',
    values: null,
    allowed_operators: ['contains', 'does not contain'],
    icon: 'editor-text-mono'
  },
  duration_seconds: {
    type: 'range',
    numeric: true,
    title: 'Duration (s)',
    icon: 'list-unordered-mono'
  },
  status: {
    title: 'Status',
    multiple: true,
    queryFn: (_, data) => {
      const searchTerm = (data?.filters?.searchTerm ?? '').toLowerCase();
      return {
        options: [
          { label: 'Active', value: 'active' },
          { label: 'Inactive', value: 'inactive' }
        ].filter((option) => option.label.toLowerCase().includes(searchTerm))
      };
    },
    queryKey: 'video_statuses.options',
    icon: 'status-mono',
    allowed_operators: ['is', 'is not']
  }
};
